module.exports={
    label: {
        // all: '全部尺寸',
        search:'検索する',
        updateAll:'すべて更新',
        bindUpdateAll:'すべてを連携',
        rebind:'連携されていない再連携',
        upgradeAll:'すべてをアップグレード',
        import:'インポート',
        // bindUpdatePart:'绑 定',
        // rouseAll:'唤 醒',
        // deleteAll:'删 除',
        queryText:'サイズ検索を選択してください',
        submiting: '提出中...',
        operation:{
            operation:'運営',
            more:'詳細',
            bindUpdatePart:'連携',
            rouseAll:'起きて',
            deleteAll:'削除する',
            downloadLabel:'棚札シートをダウンロードする',
            downloadBind:'バインディングテーブルをダウンロード',
            batchUpdate:'更新する',
            reset:'リセット',
            upgradeESL:'アップグレードする',
            importBinding:'バインディングテーブルのインポート'
        },
        table:{     //标签信息
        	index:'番号',
        	mac:'MACアドレス',
        	screenSize:'サイズ(")',
        	battery:'力(%)',
        	lastupdate:'最終放送時間',
        	updateTime:'最終更新時間',
        	gatewayMac:'連携ゲートウェイ',
        	onlineStatus:'オンライン状態',
        	operation:'運営',
            bindUpdate:'バインド',
        	rouse:'起きて',
        	delete:'削除する',
            online:'オンライン',
            offline:'オフライン'
        },
        table2:{
            operation:'運営',
            update:'修正',
            delete:'削除する'
        },
        equipmentInfo:'デバイス情報',
        devices:{   //设备信息
            Manufacturer:'メーカー：',
            battery:'力：',
            temperature:'温度：',
            runningTime:'実行時間：',
            rssi:'校正距離：',
            firmwareVersion:'ファームウェアバージョン：',
            hardwareVersion:'ハードウェアのバージョン：',
            screenInfo:'画面情報：',
            chipInfo:'チップ情報：',
            // screenInfos:[
            // {
            //     key:'0001',
            //     value:'1.54"(152*152) 黑白',
            //     size:'1.54',
            //     rotate:'向左旋转90°'
            // },{
            //     key:'0002',
            //     value:'2.13"(212*104) 黑白',
            //     size:'2.13',
            //     rotate:''
            // },{
            //     key:'0003',
            //     value:'2.13"(250*122) 黑白',
            //     size:'2.13',
            //     rotate:''
            // },{
            //     key:'0004',
            //     value:'2.9"(296*128) 黑白',
            //     size:'2.9',
            //     rotate:''
            // },{
            //     key:'0005',
            //     value:'4.2"(300*400) 黑白',
            //     size:'4.2',
            //     rotate:'向左旋转90°'
            // }],
            hardwareInfos:[
            {
                key:'0001',
                value:'MO95SF6_V1.0'
            },{
                key:'0002',
                value:'MS107F6_V1.0'
            },{
                key:'0003',
                value:'MS105F6_V1.4'
            },{
                key:'0004',
                value:'MS106F6_V1.0'
            },{
                key:'0005',
                value:'MS116F6_V1.0'
            },{
                key:'0006',
                value:'MS117F6_V1.0'
            },{
                key: '0007',
                value: 'MS127F6_V1.0'
            },{
                key:"0008",
                value:"MS128F6_V1.0"
            },{
                key:"0009",
                value:"MS134F6_V1.0"
            },{
                key:"000A",
                value:"MS132F6_V1.0"
            }],
            chipInfos:[
            {
                key:'01',
                value:'Nordic Semi, nRF52810'
            }]

        	// mac:'Mac地址：',
        	// type:'型号：',
        	// screenSize:'屏幕尺寸：',
        	// battery:'电量：',
        	// software:'软件版本：',
        	// protocolStack:'协议栈版本：',
        	// manufacturer:'制造商：',
        	// hardware:'硬件版本：',
        	// heartbeat:'广播时长：'
        	// upgrade:'升 级',
        },
        isHaveGateway:'最初にゲートウェイを追加してください',
        preview:'プレビューを表示',
        bindProducts:'製本品',
        cancel:'キャンセル',
        sure:'確定',
        hint:'ヒント',
        labelLight:{   //标签灯
            green1:'/static/images/label_green_1.png',
            green2:'/static/images/label_green_2.png',
            blue1:'/static/images/label_blue_1.png',
            blue2:'/static/images/label_blue_2.png',
            red1:'/static/images/label_red_1.png',
            red2:'/static/images/label_red_2.png'
        },
        labelLightMsg:{   //标签灯提示信息
            green:'緑の光',
            red:'レッドライト',
            blue:'明るい青色光',
            success:'棚札 {mac}：{color}コマンドが正常に送信されました',
            fail:'棚札 {mac}：{color}コマンドの送信に失敗しました',
            unbind:'棚札 {mac}：現在の棚札はゲートウェイに連携されていません',
            noLabel:'棚札 {mac}：現在の棚札は存在しません',
            chooseLabel:'点灯する棚札を選択してください',
            color:[{
                key:'1',
                value:'ブルーライト'
            },{
                key:'2',
                value:'青信号'
            },{
                key:'3',
                value:'赤信号'
            }]
        },
        bindRelation:{   //绑定商品-新增和修改绑定关系
            title:'連携',
            title2:'修正',
            add:'新しいテンプレート',
            del:'削除する',
            save:'保存',
            saving:'保存中...',
            id:'ID：',
            templates:'テンプレート：',
            placeholder1:'商品IDを入力してください',
            templateType:{
                common:'よく使われる',
                promotion:'昇進',
                activity:'活動'
            },
            effect:{
                valid:'有効',
                invalid:'無効です'
            },
            limitMsg:'連携されたテンプレートが7つの上限に達したため、これ以上追加できません',
            getTemplateFail:'このサイズのすべてのテンプレートを取得できませんでした！ もう一度やってください',
            noTemplate:'テンプレートは存在しません',
            noLabel:'棚札は存在しません',
            noProduct:'この製品情報がない場合は、最初にインポートまたは追加してください',
            success:'正常に連携します',
            modifySuccess:'バインディングの正常な変更',
            fail:'連携に失敗しました',
            delFail:'削除できませんでした',
            noBind:'バインディングゲートウェイなし',
            tip:{
                product:'ID',
                label:'棚札',
                template:'テンプレート名'
            },
            validate:{
                id:'商品IDを入力してください',
                isNum:"文字または数字を入力してください",
                noTemplates:'テンプレートを選択してください',
                noTemplatesData:'棚札には対応するサイズのテンプレートがありません',
                bindGateway:'最初に棚札をゲートウェイに連携してください',
                noPermission: 'テンプレートを表示する権限がありません'
            }
            
        },
        delBindRelation:{   //绑定商品-删除绑定关系
            dialogMsg:'棚札{mac}と商品{id}の間のバインディングを削除してもよろしいですか',
            dialogTitle:'削除する',
            success:'棚札と商品の結合関係を正常に削除しました',
            fail:'棚札と商品の結合関係を削除できませんでした',
            noBindRelation:'連携関係が削除されました。再度操作する必要はありません'
        },
        dialogLabelUpdateAll:{ //标签管理-更新当前门店所有标签弹框
            dialogTitle:'更新する',
            dialogMsg:'現在のストアのすべての棚札を更新してもよろしいですか',
            success:'すべての更新コマンドが正常に送信されました。後でページを更新して最新のデータを取得してください',
            fail:'すべての更新コマンドを送信できませんでした',
            hint:'棚札の更新が現在進行中です。棚札の更新が完了するまでお待ちください',
            input:'最初に棚札をインポートしてください'
        },
        dialogBindUpdateAll:{ //标签管理-绑定当前门店所有未绑定标签弹框
            dialogTitle:'連携',
            dialogMsg:'現在のストアのすべての棚札をゲートウェイに連携しますか',
            success:'すべての連携手順が正常に送信されました。後でページを更新して最新のステータスを取得してください',
            fail:'すべてのバインディング指示を送信できませんでした',
            input:'最初に棚札をインポートしてください'
        },
        dialogRebind:{ //标签管理-绑定当前门店所有未绑定标签弹框
            dialogTitle:'連携',
            gateway:'ゲートウェイ ',
            dialogMsg:'現在のストアにあるすべての連携されていない棚札を再連携しますか？',
            success:'ゲートウェイに再連携コマンドを正常に送信しました',
            fail:'ゲートウェイに再連携コマンドを送信できませんでした',
            isSend:'ゲートウェイはビジーです。ゲートウェイが処理を完了するまで待ってから、コマンドを再送信してください',
            isHaveGateway:'最初にゲートウェイを追加してください'
        },
        dialogUpgradeAll:{ //标签管理-批量升级
            dialogTitle:'アップグレードする',
            input:'最初に棚札をインポートしてください',
            versionInfoFail:'棚札のハードウェアバージョン番号の検索に失敗しました',
            upgradeSuccess:'アップグレード手順が正常に送信されました。棚札ハードウェアのアップグレード中はゲートウェイをオンラインにしてください...',
            upgradeFail:'アップグレードの指示を送信できませんでした',
            versionNotEmpty:'ファームウェアバージョンは空にできません',
            macNotEmpty:'MACアドレスは空にできません',
            version:'ファームウェアバージョン',
            mac:'Macアドレス',
            tip:'選択してください',
            hint:'最初にアップグレードする棚札を選択してください',
            fail1:'棚札はゲートウェイに連携されていません',
            fail2:'棚札は存在しません',
            label:'棚札 ',
            noPermission:'アップグレードに失敗しました、権限がありません'
        },
        dialogUpgradeOne:{
            upgradeESL:'アップグレードする',
            dialogTitle:'アップグレードする',
            tip:'この機能は、現在の棚札ハードウェアバージョンをアップグレードします',
            upgradeSuccess:'アップグレード手順が正常に送信されました。棚札ハードウェアのアップグレード中はゲートウェイをオンラインにしてください...',
            upgradeFail:'アップグレードの指示を送信できませんでした',
            notExist:'棚札ハードウェアアップグレードパッケージが存在しません',
            notBind:'現在の棚札はゲートウェイに連携されていません',
            notEsl:'この棚札なし',
            noPermission:'アップグレードに失敗しました、権限がありません',
            chooseLabel:'アップグレードする棚札を選択してください',
            noType:'棚札には、対応するタイプのファームウェアアップグレードパッケージがありません'
        },
        dialogBindUpdatePart:{ //标签管理-绑定标签弹框
            dialogTitle:'連携',
            dialogMsg:'選択した棚札を連携しますか',
            hint:'最初にゲートウェイに連携する棚札を選択してください',
            success:'バッチバインディングの指示が正常に送信されました。後でページを更新して最新のデータを取得してください',
            fail:'バッチバインディング命令の送信に失敗しました'
        },
        dialogLabelUpdatePart:{ //标签管理-更新选中标签弹框
            dialogTitle:'更新する',
            dialogMsg:'選択した棚札を更新してもよろしいですか',
            hint:'最初に更新する棚札を選択してください',
            success:'バッチ更新コマンドが正常に送信されました。後でページを更新して最新のデータを取得してください',
            fail:'バッチ更新コマンドの送信に失敗しました',
            fail1:'棚札はゲートウェイに連携されていません',
            fail2:'対応する棚札がインポートされていません',
            fail3:'棚札で連携されたテンプレートは空のテンプレートです',
            fail4:'商品は棚札に連携されていません',
            fail5:'棚札が連携されているテンプレートが存在しません',
            fail6:'棚札で連携された商品は存在しません',
            label:'棚札 '
        },
        dialogReset:{ //标签管理-复位标签弹框
            dialogTitle:'リセット',
            dialogMsg:'選択した棚札をリセットしてもよろしいですか',
            hint:'最初にリセットする棚札を選択してください',
            success:'バッチリセットコマンドが正常に送信されました。後でページを更新して最新のデータを取得してください',
            fail:'バッチリセットコマンドの送信に失敗しました',
            fail1:'棚札はゲートウェイに連携されていません',
            fail2:'棚札は存在しません',
            label:'棚札 '
        },
        dialogRouseAll:{ //标签管理-唤醒选中标签弹框
            dialogTitle:'起きて',
            dialogMsg:'選択した棚札をウェイクアップしますか',
            hint:'最初に起動する棚札を選択してください',
            success:'バッチウェイクアップコマンドが正常に送信されました。後でページを更新して最新のステータスを取得してください',
            fail:'バッチウェイクアップコマンドの送信に失敗しました'
        },
        dialogDelAll:{ //标签管理-删除选中标签弹框
            dialogTitle:'削除する',
            dialogMsg:'選択した棚札を削除してもよろしいですか',
            hint:'最初に削除する棚札を選択してください',
            success:'棚札がバッチで正常に削除されました',
            fail:'棚札を一括で削除できませんでした',
            noPermission:'許可なくバッチで棚札を削除できませんでした'
        },
        dialogBindUpdate:{ //标签管理-绑定弹框
            dialogTitle:'連携',
            dialogMsg:'棚札をMACアドレス{mac}に連携しますか',
            success:'連携の指示が正常に送信されました。後でページを更新して最新のステータスを取得してください',
            // noDevice:'没有网关检测到此设备！',
            fail:'連携指示を送信できませんでした'
        },
        dialogRouse:{ //标签管理-唤醒弹框
            dialogTitle:'起きて',
            dialogMsg:'MACアドレス{mac}の棚札をウェイクアップしてもよろしいですか',
            success:'スリープ解除コマンドが正常に送信されました。後でページを更新して最新のステータスを取得してください',
            unbind:'棚札はゲートウェイに連携されていません',
            fail:'ウェイクコマンドを送信できませんでした'
        },
        dialogDel:{ //标签管理-删除弹框
            dialogTitle:'削除する',
            dialogMsg:'MACアドレス{mac}の棚札を削除してもよろしいですか',
            success:'棚札を削除しました',
            fail:'棚札を削除できませんでした',
            noDevice:'この棚札デバイスは存在しません',
            noPermission:'棚札を削除できませんでした。権限がありません'
        },
        // dialogUpgrade:{ //标签管理-升级弹框
        //     dialogTitle:'升 级',
        //     dialogMsg:'确定升级当前设备吗?',
        //     chooseLabel:'请选择标签！'
        // },
        formatTime:{  //秒 转 (天 时 分)
            day:' days ',
            hour:':',
            minute:'',
        },
        getTemplateAndPro:{ //根据标签获取模板和商品数据
            unbind:'棚札は商品に連携されていません',
            fail:'棚札テンプレートと商品データを取得できませんでした',
            unbindTp:'この棚札に連携されたテンプレートは存在しません'
        },
        queryLabel:{ //查询标签
            fail:'検索棚札が失敗しました'
        },
        getPrefix:{
            fail:'棚札プレフィックスを取得できませんでした'
        },
        permission:{  //数据库数据，判断权限，不可改动
            delLabel:'棚札を削除',
            addLabel:'棚札を追加'
        },
        upload:{
            success:'棚札のインポートが完了しました、{success}つ成功、{fail}つ失敗',
            fail:'棚札をインポートできませんでした',
            msg:'アップロードされるファイルはExcelスプレッドシートのみです',
            noPermission:'棚札のインポートに失敗しました、権限がありません',
            downloadText: 'インポート処理結果ファイルをダウンロードする'
        },
        uploadBindRelation:{
            success:'インポートが完了しました、{success}つ成功、{fail}つ失敗',
            fail:'インポートに失敗しました',
            msg:'アップロードされるファイルはExcelスプレッドシートのみです'
        },
        labelFilter:{
            label:'電子棚札',
            deviceState:'デバイスの状態',
            allDevice:'すべての機器',
            labelStatus:{
                online:'オンライン',
                offline:'オフライン',
                bindGateway:'連携されたゲートウェイ',
                unbindGateway:'連携されていないゲートウェイ',
                lowPower:'ローバッテリー'
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/label.js